/**
 * Card Carousel Autoplay on Hover
 * Enables autoplay for product card swipers only when hovering over the card
 */
(function() {
  'use strict';

  // Wait for DOM and swiper initialization
  function initCardCarouselAutoplay() {
    const cardContainers = document.querySelectorAll('.card__container');
    
    cardContainers.forEach((cardContainer) => {
      const autoplayConfigScript = cardContainer.querySelector('[data-card-autoplay-config]');
      
      // Only process cards with autoplay enabled
      if (!autoplayConfigScript) return;
      
      let autoplayConfig;
      try {
        autoplayConfig = JSON.parse(autoplayConfigScript.textContent);
      } catch (e) {
        console.warn('Failed to parse card autoplay config', e);
        return;
      }
      
      if (!autoplayConfig.enabled) return;
      
      // Find the slideshow-section within this card
      const slideshowSection = cardContainer.querySelector('slideshow-section');
      if (!slideshowSection) return;
      
      let swiperInstance = null;
      let autoplayDelay = autoplayConfig.delay || 3000;
      
      // Function to get or wait for swiper instance
      function getSwiperInstance() {
        if (slideshowSection.swiper) {
          return slideshowSection.swiper;
        }
        return null;
      }
      
      // Function to start autoplay
      function startAutoplay() {
        const swiper = getSwiperInstance();
        if (!swiper || !swiper.autoplay) return;
        
        // Update autoplay delay if needed
        if (swiper.params.autoplay && swiper.params.autoplay.delay !== autoplayDelay) {
          swiper.params.autoplay.delay = autoplayDelay;
        }
        
        // Start autoplay
        if (swiper.autoplay.running === false) {
          swiper.autoplay.start();
        }
      }
      
      // Function to stop autoplay
      function stopAutoplay() {
        const swiper = getSwiperInstance();
        if (!swiper || !swiper.autoplay) return;
        
        // Stop autoplay
        if (swiper.autoplay.running === true) {
          swiper.autoplay.stop();
        }
      }
      
      // Wait for swiper to be initialized
      function waitForSwiper() {
        const checkInterval = setInterval(() => {
          const swiper = getSwiperInstance();
          if (swiper && swiper.autoplay) {
            clearInterval(checkInterval);
            swiperInstance = swiper;
            
            // Stop autoplay initially - we'll start it on hover
            if (swiper.autoplay.running) {
              swiper.autoplay.stop();
            }
            
            setupHoverListeners();
          }
        }, 100);
        
        // Timeout after 5 seconds
        setTimeout(() => {
          clearInterval(checkInterval);
        }, 5000);
      }
      
      // Setup hover event listeners
      // function setupHoverListeners() {
      //   // Get the card container or the closest parent that makes sense for hover
      //   // Try multiple selectors to find the best hover target
      //   const hoverTarget = cardContainer.closest('.collection__grid__item') || 
      //                      cardContainer.closest('.card__picture-container')?.parentElement ||
      //                      cardContainer;
        
      //   if (!hoverTarget) return;
        
      //   // Mouse enter - start autoplay
      //   hoverTarget.addEventListener('mouseenter', (e) => {
      //     // Make sure we're only starting autoplay for this specific card
      //     e.stopPropagation();
      //     startAutoplay();
      //   });
        
      //   // Mouse leave - stop autoplay
      //   hoverTarget.addEventListener('mouseleave', (e) => {
      //     // Make sure we're only stopping autoplay for this specific card
      //     e.stopPropagation();
      //     stopAutoplay();
      //   });
        
      //   // Also handle touch events for mobile (optional)
      //   hoverTarget.addEventListener('touchstart', () => {
      //     startAutoplay();
      //   }, { passive: true });
      // }

      function setupHoverListeners() {
      const hoverTarget = cardContainer.closest('.collection__grid__item') || 
                        cardContainer.closest('.card__picture-container')?.parentElement ||
                        cardContainer;

      if (!hoverTarget) return;

      // Desktop hover
      hoverTarget.addEventListener('mouseenter', (e) => {
        e.stopPropagation();
        startAutoplay();
      });

      hoverTarget.addEventListener('mouseleave', (e) => {
        e.stopPropagation();
        stopAutoplay();
      });

      // Mobile: stop autoplay when card scrolls out of viewport
      // (replaces the old touchstart which triggered autoplay on scroll-past)
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              stopAutoplay();
            }
          });
        },
        { threshold: 0.1 }
      );

      observer.observe(hoverTarget);
    }
      
      // Start waiting for swiper initialization
      waitForSwiper();
    });
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCardCarouselAutoplay);
  } else {
    initCardCarouselAutoplay();
  }
  
  // Re-initialize when Shopify sections load (for theme editor)
  document.addEventListener('shopify:section:load', initCardCarouselAutoplay);
  
})();
